<template>
	<div class="form-actions">
	  <button type="submit" class="btn btn-primary">Save Changes</button>
	  <button type="button" @click="onCancel" class="btn btn-secondary">Cancel</button>
	</div>
</template>
<script>
  export default {
    name: 'action-button',
    methods: {
      onCancel: function () {
        this.$emit('oncancel')
      }
    }
  }
</script>